export enum StatusRequest {
    None = 'none',
    Init = 'init',
    Success = 'success',
    Failed= 'failed'
}
